module.exports = __webpack_public_path__ + "img/layout_quarter_three_quarters.858a5221.webp";